// extracted by mini-css-extract-plugin
export default {"root":"HomePage_root__cI9ro","main":"HomePage_main__Io9UL","logoWrapper":"HomePage_logoWrapper__r8MST","headingWrapper":"HomePage_headingWrapper__tpvxq"};